/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_Pricing_PopularInputs */

const en_platform_pricing_popular = /** @type {(inputs: Platform_Pricing_PopularInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Most popular`)
};

const pl_platform_pricing_popular = /** @type {(inputs: Platform_Pricing_PopularInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Najczęściej wybierany`)
};

/**
* | output |
* | --- |
* | "Most popular" |
*
* @param {Platform_Pricing_PopularInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const platform_pricing_popular = /** @type {((inputs?: Platform_Pricing_PopularInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Pricing_PopularInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_platform_pricing_popular(inputs)
	return en_platform_pricing_popular(inputs)
});